if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        this.onButtonClick = this.onButtonClick.bind(this);
      }

      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || this.buttonElement === button) return;

        if (this.buttonElement) {
          this.buttonElement.removeEventListener('click', this.onButtonClick);
        }

        this.buttonElement = button;
        this.buttonElement.addEventListener('click', this.onButtonClick);
      }

      disconnectedCallback() {
        if (!this.buttonElement) return;
        this.buttonElement.removeEventListener('click', this.onButtonClick);
        this.buttonElement = null;
      }

      onButtonClick(event) {
        this.expandShowMore(event);
        const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
        if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
          nextElementToFocus.querySelector('input').focus();
        }
      }

      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
